const request = (endpoint, options = { headers: {} }) =>
  fetch(`https://api.one-in-three.com/${endpoint}`, {
    method: "GET",
    ...options,
    headers: {
      "X-Auth-Token": window.AUTH_TOKEN,
      ...options.headers
    }
  });

export default request;
export const get = endpoint => request(endpoint);
export const postJSON = (endpoint, body) =>
  request(endpoint, {
    method: "POST",
    body: JSON.stringify(body),
    headers: {
      "Content-Type": "application/json"
    }
  });
